module.exports = __webpack_public_path__ + "static/media/IMG_4628 vanitu birds eye.294ef891.JPG";